import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import IconButton from "@mui/material/IconButton";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CloseIcon from "@mui/icons-material/Close";

import ProjectFilter from "../../../layouts/ShoppingLayout/ProjectFilter";
import useAuth from "../../../hooks/useAuth";
import AddInventoryItems from "./AddInventoryItems";
import { fullWidthDialog } from "src/constants/dialog";

export default function InventoryItemModal({
  onClose,
  onItemAdded,
  processNewItem,
  projectId: initialProjectId,
}) {
  const { user } = useAuth();
  const { settings } = user.company;
  const [projectId, setProjectId] = useState(initialProjectId);
  const onSelectProject = id => {
    setProjectId(id);
  };

  return (
    <Dialog
      open
      fullWidth
      maxWidth="lg"
      onClose={onClose}
      aria-labelledby="dialog-title"
      disableEnforceFocus
      sx={fullWidthDialog}
    >
      <DialogTitle id="dialog-title">
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              fontSize={22}
              fontWeight={500}
              color="textPrimary"
              sx={{ textAlign: { xs: "center", md: "left" } }}
            >
              Add More Items
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 8 }}>
            <Box display="flex" alignItems="center">
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
                sx={{ display: { xs: "none", md: "block" } }}
              >
                <Typography variant="body1" color="textPrimary">
                  Choose a {settings.filter_field2}
                </Typography>
                <Typography></Typography>
              </Breadcrumbs>
              <Box width="300px">
                <ProjectFilter
                  size="small"
                  projectId={projectId}
                  onSelectProject={onSelectProject}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <AddInventoryItems
          projectId={projectId}
          onItemAdded={onItemAdded}
          processNewItem={processNewItem}
        />
      </DialogContent>
      <DialogActions>
        <Box display="flex" p={1.5}>
          <Button variant="outlined" onClick={onClose} color="primary">
            Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
